import React from "react";
import InputTextComponent from "../../../../components/forms/InputTextComponent";
import { Form, Col, Row, FormGroup, Input, Label } from "reactstrap";
const translator = require("../../../../utils/translator/translator");

class Overview extends React.PureComponent 
{
    state = {
        dropdownOpen: false
    }
    render() 
    {
        return (
            <Form>
                <Row className="mb-3">
                    <Col>
                        <InputTextComponent
                            autoComplete="off"
                            placeholder={translator.getLabel("venue_dialogue_order_number")}
                            value={this.props.values.orderNumber}
                            onValueChange={(value) => this.props.handleValueChange("orderNumber", value)}
                            inputTextType="text"
                            error={this.props.error.fieldName === "orderNumber" ? this.props.error.message : ""}
                            internalRef={this.props.inputFieldRef}
                            required
                        />
                    </Col>
                </Row>

                <Row className="mb-3">
                    <Col md={6}>
                        <FormGroup floating>
                            <Input
                                id="dispatchType"
                                placeholder={translator.getLabel("venue_dialogue_dispatch_type")}
                                value={this.props.values.dispatchType}
                                disabled
                            />
                            <Label>
                                {translator.getLabel("venue_dialogue_dispatch_type")}<span className="text-danger">*</span>
                            </Label>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup floating>
                            <Input
                                type="select"
                                name="paymentMethod"
                                placeholder={translator.getLabel("venue_dialogue_payment")}
                                value={this.props.values.paymentMethod}
                                onChange={(e) =>
                                {
                                    this.props.handleValueChange("paymentMethod", e.target.value)
                                }}
                                invalid={this.props.error.fieldName === "paymentMethod" ? this.props.error.message : ""}
                            >
                                {
                                    (this.props.paymentMethods.length)
                                        ? this.props.paymentMethods.map(paymentMethod => <option value={paymentMethod.value}>{paymentMethod.label}</option>)
                                        : <option disabled>{translator.getLabel("no_options")}</option>
                                }
                            </Input>
                            <Label>
                                {translator.getLabel("venue_dialogue_payment")}
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }

}

export default Overview